/**
 * @fileoverview Utility building the URL to an agent's details page with the
 * Usage tab pre-selected (the `#usage` hash matches the AgentDetails scene's
 * Usage tab id). Shared by every "View usage" link so the details route and
 * hash contract live in one place.
 * @owner @Appboy/agent-console
 */

/** Returns the URL to the agent details page with the Usage tab selected. */
export const agentUsageUrlGetter = (agentId: string, appGroupId: string): string => {
  return `/agent_console/agents/${agentId}/${appGroupId}#usage`;
};
